import React from 'react';

import BackNavbar from '../navbar/BackNavbar';
import SearchBar from '../navbar/SearchBar';
import LoadingScreen from './LoadingScreen';

/**
 * Shell shown when a lazy route is loading.
 * Keeps navbar visible instead of full-screen flash.
 */
function LoadingLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <BackNavbar />
      <SearchBar />
      <div className="flex flex-col justify-center items-center min-h-[50vh] px-4 py-12">
        <div className="w-full max-w-sm rounded-2xl border border-slate-200/80 bg-white p-10 shadow-sm">
          <LoadingScreen type="spin" color="#4f46e5" />
        </div>
      </div>
    </div>
  );
}

export default LoadingLayout;
